<template>
  <transition name="slide-fade">
    <div style="min-height: 85vh !important;">
      <div class=" testStep" >
        <div class="" style=" background: rgba(255, 255, 255, 0.8)">
          <div class="uk-container uk-padding">
            <h1 class="uk-heading-line uk-text-center  specHeading" >Academic Calendar</h1>

            <div uk-grid>
              <div class="uk-width-1-1 uk-width-1-1@s uk-width-1-1@l " style=" border-radius: 5px !important;">
                <div class="" style=" border-radius: 5px !important; ">
                  <div class="uk-child-width-1-1  uk-padding-small uk-padding-remove-horizontal"  uk-grid >
                    <div style="padding-left: 5px !important;">
                      <div  uk-grid >
                        <div class="uk-width-expand@s">
                          <ul style="list-style: none">
                            <li >

                              <div class="">
                                <div class="">
                                  <select ref="dCalendar" class="uk-select" v-on:change="CalendarChoice">
                                    <option disabled selected="selected">Please select a calendar to download</option>
                                    <option value="2018/2019">Academic Calendar 2018/2019</option>
                                  </select>
                                </div>

                              </div>
                            </li>
                            <!--<li>
                              <a class="uk-accordion-title" href="#">Item 3</a>
                              <div class="uk-accordion-content">
                                <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat proident.</p>
                              </div>
                            </li>-->
                          </ul>
                        </div>
                        <div class="uk-width-auto@s">
                          <div class="uk-margin " style="padding-left: 30px">
                            <a :href="calendarUrl" target="_blank" class="uk-button uk-button-primary">Download</a>
                          </div>
                        </div>

                      </div>

                    </div>

                  </div>

                </div>


                <hr>
                <div class="uk-flex uk-flex-between">
                  <div>
                    <a href="#" class="uk-button uk-button-default" @click="decrementMonth()" style="color: rgb(197,179,88) !important; background: white !important;">
                      <span class="uk-visible@s" uk-icon="chevron-left"  ></span>
                      Previous
                    </a>
                  </div>
                  <div>
                    <a href="#" class="uk-button uk-button-default " style="color: rgb(197,179,88) !important; background: white !important;"  @click="incrementMonth()">
                      Next
                      <span class="uk-visible@s" uk-icon="chevron-right"  ></span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="uk-width-1-1 uk-width-1-1@s uk-width-4-4@l ">


                <h3 class="uk-heading-line uk-text-center uk-text-bold uk-text-uppercase"><span>{{ getMonthData.monthName }}  {{ getMonthData.year }}</span></h3>
                <!-- <div class="uk-alert-primary " uk-alert>
                   <a class="uk-alert-close" uk-close></a>
                   <span class="uk-text-small uk-text-muted"> Dates are shown in YYYY-MM-DD format</span>
                 </div>-->
                <div class="uk-margin-left">
                  <div class="uk-child-width-1-1@m" uk-grid>
                    <div v-for="(item, index) in getEvents" :class="[setStyle(index) ? 'uk-background-muted' : '', 'uk-padding-small']" class="uk-margin-remove-top" :key="index">
                      <div  uk-grid>
                        <!--<div class="uk-width-auto@m"><img :src="'http://192.168.10.204:4000/' + item.eventImage" alt="" height="70" width="70"></div>-->
                        <div class="uk-width-expand@m">
                          <div class="uk-margin-small">
                            <dl class="uk-description-list uk-description-list-divider uk-margin-remove-bottom" >
                              <dt>
                                <div class="uk-heading-bullet uk-padding-small" style="color: #033860 !important;">
                                  <span style="font-size: medium">{{ item.eventName}}</span> <br>
                                  <span class="uk-text-capitalize uk-text-muted" style="font-size: 10pt; color: #333333 ">
                              {{ item.eventDate | moment("dddd, Do MMMM YYYY") }}
                            </span>
                                </div>
                              </dt>
                            </dl>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </transition>
</template>

<script>
  export default {
    name: "newCalendar",
    data(){
      return{
        previousMonth: null,
        thisMonth: null,
        nextMonth: null,
        thisYear: null,
        calendarUrl: null
      }
    },
    computed: {

      getCurrentMonth() {
        return this.$store.state.currentMonthArray
      },
      getMonthData(){
        return this.$store.state.currentMonth
      },
      getEvents(){
        return this.$store.state.currentAcademicsList
      }
    },
    methods: {
      CalendarChoice(){
        console.log(this.$refs.dCalendar.value)
        if (this.$refs.dCalendar.value === '2018/2019'){
          this.calendarUrl = '/AcademicCalendar2018_2019.pdf'
        }
      },
      toDate: function (dateStr) {
        const [day, month, year] = dateStr.split("-")
        //return new Date(year, month - 1, day)
        return  new Date(dateStr.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"))
      },

      setStyle(item){
        return item % 2 === 0;
      },
      decrementMonth(){
        if (this.previousMonth === 1 && this.thisMonth === 2) {

          this.previousMonth = 12;
          this.thisMonth = 1;
          //this.thisYear--;
          this.nextMonth = 2;
          /*console.log("Previous Month " + this.previousMonth)
          console.log("Current Month " + this.thisMonth)
          console.log("Next Month " + this.nextMonth)
          console.log("This Year " + this.thisYear)*/
        }
        else if (this.previousMonth === 12 && this.thisMonth === 1) {
          this.previousMonth = 11;
          this.thisMonth = 12;
          this.thisYear--;
          this.nextMonth = 1;
          /*console.log("Previous Month " + this.previousMonth)
          console.log("Current Month " + this.thisMonth)
          console.log("Next Month " + this.nextMonth)
          console.log("This Year " + this.thisYear)*/
        } else
        if (this.previousMonth === 11 && this.thisMonth === 12) {
          this.previousMonth = 10;
          this.thisMonth = 11;
          //this.thisYear--;
          this.nextMonth = 12;
          // console.log("Previous Month " + this.previousMonth)
          // console.log("Current Month " + this.thisMonth)
          // console.log("Next Month " + this.nextMonth)
          // console.log("This Year " + this.thisYear)
        }
        else {
          this.previousMonth--
          this.thisMonth--
          this.nextMonth--
          // console.log("Previous Month " + this.previousMonth)
          // console.log("Current Month " + this.thisMonth)
          // console.log("Next Month " + this.nextMonth)
          // console.log("This Year " + this.thisYear)
        }

        let self = this
        setTimeout(function () {
          self.$store.dispatch('getAcademicCurrentMonth',
                  {
                    year: self.thisYear,
                    month: self.thisMonth
                  })
        }, 500)
      },
      incrementMonth(){
        if (this.nextMonth === 12 && this.thisMonth === 11) {

          this.previousMonth = 11;
          this.thisMonth = 12;
          //this.thisYear++;
          this.nextMonth = 1;
          /*console.log("Previous Month " + this.previousMonth)
          console.log("Current Month " + this.thisMonth)
          console.log("Next Month " + this.nextMonth)
          console.log("This Year " + this.thisYear)*/
        }else
        if (this.nextMonth === 1 && this.thisMonth === 12) {
          this.previousMonth = 12;
          this.thisMonth = 1;
          this.thisYear++;
          this.nextMonth = 2;
          /*console.log("Previous Month " + this.previousMonth)
          console.log("Current Month " + this.thisMonth)
          console.log("Next Month " + this.nextMonth)
          console.log("This Year " + this.thisYear)*/
        } else
        if (this.nextMonth === 2 && this.thisMonth === 1) {
          this.previousMonth = 1;
          this.thisMonth = 2;
          //this.thisYear--;
          this.nextMonth = 3;
          /*console.log("Previous Month " + this.previousMonth)
          console.log("Current Month " + this.thisMonth)
          console.log("Next Month " + this.nextMonth)
          console.log("This Year " + this.thisYear)*/
        }
        else {
          this.previousMonth++
          this.thisMonth++
          this.nextMonth++
          /*console.log("Previous Month " + this.previousMonth)
          console.log("Current Month " + this.thisMonth)
          console.log("Next Month " + this.nextMonth)
          console.log("This Year " + this.thisYear)*/
        }

        let self = this
        setTimeout(function () {
          self.$store.dispatch('getAcademicCurrentMonth',
                  {
                    year: self.thisYear,
                    month: self.thisMonth
                  })
        }, 500)


      }
    },
    mounted() {
      let s =  new Date()
      console.log(s.getMonth() + 1)
      console.log(s.getFullYear() )
      this.thisMonth = s.getMonth() + 1
      this.previousMonth = this.thisMonth - 1

      if (this.thisMonth + 1 === 13) {
        this.nextMonth = 1
        this.thisYear = s.getFullYear()
      }else{
        this.nextMonth = this.thisMonth + 1
        this.thisYear = s.getFullYear()
      }


      this.$store.dispatch('getAcademicCurrentMonth',
              {
                year: s.getFullYear(),
                month: s.getMonth() + 1
              })
    }
  }
</script>

<style scoped>
  .testStep{
    background-image: url('~@/assets/watch-1893395_1920.jpg');
  }
  @media screen and (max-width:600px){


    h3{
      font-size: 1.3em !important;
    }
    h1{
      font-size: 1.4em !important;
    }
    p,li{
      font-size: 0.8em !important;
    }


  }
</style>
